import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import RealTime from './RealTime'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTTreatment = ({ patientId }) => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['PatientAppointments', `${patientId}`],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['Treatments', `${patientId}`],
      cancelRefetch: true,
    })
  }, 500)

  return (
    <RealTime
      channel="PatientProfile::TreatmentsChannel"
      onEvent={handleEvent}
      patientId={patientId}
    />
  )
}

export default RTTreatment
